// extracted by mini-css-extract-plugin
export default {"container":"ZW-z","title":"_W-z","link":"aX-z"};